<div class="landing-page-sec">
  <nav class="navbar navbar-inverse navbar-fixed-top">
    <!-- <div class="top-link-sec bg-red">
      <div class="container pad0">
        <div class="row">
          <div class="col-sm-6">
            <p>
              <i class="fa fa-envelope-o" aria-hidden="true"></i>&nbsp;support@statementgames.com</p>
          </div>
          <div class="col-sm-6 s-sec text-right">
            <ul class="social-links list-inline">
              <li>
                <a href="https://www.facebook.com/StatementGames/" target="_blank">
                  <i class="fa fa-facebook" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/statementgames" target="_blank">
                  <i class="fa fa-twitter" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a href="https://plus.google.com/u/0/104605028988485215379" target="_blank">
                  <i class="fa fa-google-plus" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div class="container">
      <div class="col-xs-12">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false"
            aria-controls="navbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="javascript:void(0)">
            <img src="assets/img/SG-landing-page-logo.png" />
          </a>
        </div>
        <div id="navbar" class="navbar-collapse collapse" aria-expanded="false" style="height: 1px;">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <a href="javascript:void(0)" class="btn btn-creat-acc" routerLink='/landing/signup'>CREATE FREE ACCOUNT</a>
            </li>

          </ul>

        </div>
      </div>
    </div>
  </nav>

  <div class="main-sec">
    <section class="banner-bg-sec nba-bg">
      <div class="container-fluid contain-wdth">
        <div class="col-xs-12">
          <div class="row">



            <div class="col-sm-6">
              <div class="video-sec">
                <!-- <iframe width="10 height="400" frameborder="0" wmode="Opaque" allowfullscreen="" src="https://www.youtube.com/embed/Izy3jkCqGXo?wmode=transparent?rel=0&autoplay=0"
                  style="margin: 20px auto;width:100%;"></iframe> -->
                <a class="video-play" href="javascript:void(0)">
                  <img alt="video-img" class="img-fluid mg0" height="400" src="assets/img/video-img (1).png" width="100%">
                  <i aria-hidden="true" class="fa fa-play video-icon"></i>
                  <div class="video-wrap-overlay"></div>
                </a>
              </div>

            </div>

            <div class="col-sm-6">
              <div class="cnt-txt">
                <!-- <h1>WHY JOIN TODAY ?</h1>
                  <ul>
                    <li>Free to join & play</li>
                    <li>Fun – new form of fantasy basketball</li>
                    <li>Compete against top basketball handicappers</li>
                    <li>Prizes & experiences valued at thousands of $$$ awarded monthly</li>
                    <li>Never any ongoing cost or obligations</li>
                    <li>We will change the way you watch NBA basketball</li>
                    <a href="javascript:void(0)" class="btn btn-creat-acc" routerLink='/landing/signup'>CREATE FREE ACCOUNT</a>
                  </ul> -->

                <h1>Why Join NBA Fantasy Basketball Today?</h1>
                <ul>
                  <li>FREE To Join & Play NBA Fantasy Basketball League</li>
                  <li>Fun – New Form Of Fantasy Basketball</li>
                  <li>Compete Against Friends & Other NBA Fantasy League Members</li>
                  <li>No Ongoing Costs Or Obligations</li>
                  <li>We Will Change The Way You Play NBA Fantasy Basketball</li>
                  <!-- <li>We will change the way you watch NBA basketball</li> -->
                  <a href="javascript:void(0)" class="btn btn-creat-acc" routerLink='/landing/signup'>CREATE FREE ACCOUNT</a>
                </ul>


              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <section class="play-sec">
      <div class="container-fluid pad0">
        <div class="co-xs-12 pad0">
          <div class="tbl-sec">
            <div class="col-md-6 cnt-pd cnt-lst tbl-cell bg-red">
              <div class="title-sec">
                <!-- <h2 class="txt-wht">How to Play</h2> -->
                <h2 class="txt-wht">How To Play NBA Fantasy Basketball</h2>
              </div>
              <ul>
                <!-- <li>Join a basketball prediction contest</li>
                <li>Choose 10 props – OVER/UNDER predictions & rank them from 10 through 1. (10 being your most confident pick)</li>
                <li>Monitor your basketball picks – earn points for correct statements</li>
                <li>How did you perform? Check your NBA prediction contest standings</li> -->

                <li>Join A NBA Fantasy Basketball Prediction League</li>
                <li>Choose 10 Props – OVER / UNDER Basketball Predictions & Rank Them From 10 Through 1. (10 Being Your Most
                  Confident Pick)</li>
                <li>Monitor Your Fantasy Basketball League – Earn Points For Correct Picks</li>
                <li>How Did You Perform? Check Your NBA Basketball League Standings</li>
                <a href="javascript:void(0)" class="btn btn-creat-acc" routerLink='/landing/signup'>CREATE FREE ACCOUNT</a>
              </ul>


            </div>
            <div class="col-md-6 cnt-pd img-sec tbl-cell text-center">
              <img src="assets/img/desktop-image.png" />
            </div>
          </div>


        </div>
      </div>
    </section>

    <section class=" testimonial-sec pad-sec">
      <div class="container">
        <div class="title-sec text-center">
          <h2 class="txt-wht">Testimonial</h2>
        </div>
        <div class="owl-carousel testimonials-carousel">

          <div class="testimonial-item">
            <div class="col-sm-12 row">
              <div class=" testimonial-cnt">
                <img src="assets/img/testimonial-3.jpg" class="pro-logo" />
                <h3>Devils Army Blog</h3>
                <span>@DevilsArmyBlog</span>
                <div class="clearfix"></div>
                <p>Hey #NJDevils fans! Are you playing tonight's game on @StatementGames? If not, you should be! </p>
                <div class="text-center">
                  <a href="javascript:void(0)" class="btn btn-creat-acc" data-toggle="modal" data-target="#myModal7">Read more</a>
                  <div class="clearfix"></div>
                  <img src="assets/img/quotes-icon.jpg" class="quotes-icon" />
                </div>
              </div>
            </div>

          </div>

          <div class="testimonial-item">
            <div class="col-sm-12 row">
              <div class=" testimonial-cnt">
                <img src="assets/img/testimonial-4.jpg" class="pro-logo" />
                <h3>The Jets Factor</h3>
                <span>@CandCJetsFactor</span>
                <div class="clearfix"></div>
                <p>Like The Jets factor Podcast? Well, we have teamed up with StatementGames to bring you, THE FAN, an exciting
                </p>
                <div class="text-center">
                  <a href="javascript:void(0)" class="btn btn-creat-acc" data-toggle="modal" data-target="#myModal3">Read more</a>
                  <div class="clearfix"></div>
                  <img src="assets/img/quotes-icon.jpg" class="quotes-icon" />
                </div>
              </div>
            </div>

          </div>


          <div class="testimonial-item">
            <div class="col-sm-12 row">
              <div class=" testimonial-cnt">
                <img src="assets/img/testimonial-5.jpg" class="pro-logo" />
                <h3>Knicks Fan TV </h3>
                <span>@KnicksFanTv</span>
                <div class="clearfix"></div>
                <p> Congratulations to @drfrejon who won last night's Knicks vs Hornets StatementGames. @drfrejon was </p>
                <div class="text-center">
                  <a href="javascript:void(0)" class="btn btn-creat-acc" data-toggle="modal" data-target="#myModal4">Read more</a>
                  <div class="clearfix"></div>
                  <img src="assets/img/quotes-icon.jpg" class="quotes-icon" />
                </div>
              </div>
            </div>

          </div>

          <div class="testimonial-item">
            <div class="col-sm-12 row">
              <div class=" testimonial-cnt">
                <img src="assets/img/testimonial-6.jpg" class="pro-logo" />
                <h3>Ben Sudderth III </h3>
                <span>@BS3Sports</span>
                <div class="clearfix"></div>
                <p> Join my #DALvsWAS Contest on .@StatementGames! ! The Winner gets a DOPE BS3 Sports Shirt! #DallasCowboys
                </p>
                <div class="text-center">
                  <a href="javascript:void(0)" class="btn btn-creat-acc" data-toggle="modal" data-target="#myModal5">Read more</a>
                  <div class="clearfix"></div>
                  <img src="assets/img/quotes-icon.jpg" class="quotes-icon" />
                </div>
              </div>
            </div>

          </div>


          <div class="testimonial-item">
            <div class="col-sm-12 row">
              <div class=" testimonial-cnt">
                <img src="assets/img/testimonial-1.jpg" class="pro-logo" />
                <h3>IslesBlog</h3>
                <span>@IslesBlog</span>
                <div class="clearfix"></div>
                <p>On December 1st, the #Isles return to their true home. It’s also the return of our next @StatementGames Contest!
                </p>
                <div class="text-center">
                  <a href="javascript:void(0)" class="btn btn-creat-acc" data-toggle="modal" data-target="#myModal1">Read more</a>
                  <div class="clearfix"></div>
                  <img src="assets/img/quotes-icon.jpg" class="quotes-icon" />
                </div>

              </div>
            </div>

          </div>


          <div class="testimonial-item">
            <div class="col-sm-12 row">
              <div class=" testimonial-cnt">
                <img src="assets/img/testimonial-2.jpg" class="pro-logo" />
                <h3>AroundThe412</h3>
                <span>@AroundThe412</span>
                <div class="clearfix"></div>
                <p>Tomorrow’s #Steelers-#Broncos contest is your last chance to get into the private contest to win #Steelers-#Chargers
                </p>
                <div class="text-center">
                  <a href="javascript:void(0)" class="btn btn-creat-acc" data-toggle="modal" data-target="#myModal2">Read more</a>
                  <div class="clearfix"></div>
                  <img src="assets/img/quotes-icon.jpg" class="quotes-icon" />
                </div>
              </div>
            </div>

          </div>



        </div>


      </div>
    </section>

    <div id="myModal7" class="modal fade playnowmodel" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <!-- <div class="modal-header">
       
          <h4 class="modal-title">Modal Header</h4>
        </div> -->
          <div class="modal-body">

            <button type="button" class="close" data-dismiss="modal">&times;</button>

            <div class="col-sm-2 text-center">
              <img src="assets/img/testimonial-1.jpg" class="ply-img"> </div>

            <div class="col-sm-10">
              <h1 class="ply-now-head">Devils Army Blog
                <br> </h1>
              <span class="ply-emai">@DevilsArmyBlog</span>
            </div>

            <div class="content-play">

              <p class="play-bodysec"> Hey
                <strong>#NJDevils </strong> fans! Are you playing tonight's game on
                <strong>@StatementGames? ? If not, you should be! </strong>
              </p>

              <p class="play-mg-btm">Here's our three lock statements:</p>


              <ul class="playmodel-list">
                <li>Tampa Bay Lightning Face off % OVER 50%</li>
                <li>Taylor Hall + Nico Hischier + Kyle Palmieri OVER 1.5 Combined PTS</li>
                <li>Tampa Bay Lightning OVER 30.5 Shots</li>
              </ul>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div id="myModal1" class="modal fade playnowmodel" role="dialog">

      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <!-- <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Modal Header</h4>
        </div> -->
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal">&times;</button>

            <div class="col-sm-2 text-center">
              <img src="assets/img/testimonial-2.jpg" class="ply-img"> </div>

            <div class="col-sm-10">
              <h1 class="ply-now-head">IslesBlog
                <br> </h1>
              <span class="ply-emai">@IslesBlog</span>
            </div>

            <div class="content-play">

              <p class="play-bodysec"> On December 1st, the
                <strong>#Isles</strong> return to their true home. It’s also the return of our next
                <strong>@StatementGames Contest! </strong>
              </p>

              <p class="play-bodysec"> Same rules: Top OVERALL point getter wins 2 tix to a NYI game (12/4 vs Jets) and group winners win $5 gift
                card!

              </p>

              <p class="play-bodysec"> Sign up for FREE here:
                <br>
                <strong>statementgames.com/#/landing/sign ...</strong>

              </p>

              <!-- <p class="play-mg-btm">Here's our three lock statements:</p> -->



            </div>
          </div>
          <!-- <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div> -->
        </div>

      </div>
    </div>

    <div id="myModal2" class="modal fade playnowmodel" role="dialog">

      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <!-- <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Modal Header</h4>
        </div> -->
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal">&times;</button>

            <div class="col-sm-2 text-center">
              <img src="assets/img/testimonial-3.jpg" class="ply-img"> </div>

            <div class="col-sm-10">
              <h1 class="ply-now-head">AroundThe412
                <br> </h1>
              <span class="ply-emai">@AroundThe412</span>
            </div>

            <div class="content-play">

              <p class="play-bodysec"> Tomorrow’s
                <strong>#Steelers-#Broncos </strong> contest is your last chance to get into the private contest to win
                <strong>#Steelers-#Chargers</strong> tickets. Don’t miss out on the action
                <br>
                <strong>@StatementGames</strong>
                <br>
                <strong>statementgames.com/#/user/lobby</strong>
              </p>

            </div>
          </div>
          <!-- <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div> -->
        </div>

      </div>
    </div>

    <div id="myModal3" class="modal fade playnowmodel" role="dialog">

      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <!-- <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Modal Header</h4>
        </div> -->
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal">&times;</button>

            <div class="col-sm-2 text-center">
              <img src="assets/img/testimonial-4.jpg" class="ply-img"> </div>

            <div class="col-sm-10">
              <h1 class="ply-now-head">The Jets Factor
                <br> </h1>
              <span class="ply-emai">@CandCJetsFactor</span>
            </div>

            <div class="content-play">

              <p class="play-bodysec">Like The Jets factor Podcast? Well, we have teamed up with
                <strong>@StatementGames</strong> to bring you, THE FAN, an exciting way to play fantasy! Go to Statementgames.com
                and join the JFP's weekly touney! Plus, listen to the show for details on how u can WIN NYJ/NE tix for Nov.25th!

              </p>

            </div>
          </div>
          <!-- <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div> -->
        </div>

      </div>
    </div>
    <div id="myModal4" class="modal fade playnowmodel" role="dialog">

      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <!-- <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Modal Header</h4>
        </div> -->
          <div class="modal-body">

            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="col-sm-2 text-center">
              <img src="assets/img/testimonial-5.jpg" class="ply-img"> </div>

            <div class="col-sm-10">
              <h1 class="ply-now-head">Knicks Fan TV
                <br> </h1>
              <span class="ply-emai">@KnicksFanTv</span>
            </div>

            <div class="content-play">

              <p class="play-bodysec"> Congratulations to
                <strong>@drfrejon</strong> who won last night's Knicks vs Hornets Statement Games.
                <strong>@drfrejon</strong> was among 6 winners of the $10 NBA Store Gift Card and he also won the Knicks Mitchell
                & Ness Snapback hat. Well done!

              </p>

            </div>
          </div>
          <!-- <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div> -->
        </div>

      </div>
    </div>
    <div id="myModal5" class="modal fade playnowmodel" role="dialog">

      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <!-- <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Modal Header</h4>
        </div> -->
          <div class="modal-body">

            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="col-sm-2 text-center">
              <img src="assets/img/testimonial-6.jpg" class="ply-img"> </div>

            <div class="col-sm-10">
              <h1 class="ply-now-head">Ben Sudderth III
                <br> </h1>
              <span class="ply-emai">@BS3Sports</span>
            </div>

            <div class="content-play">

              <p class="play-bodysec"> Join my
                <strong> #DALvsWAS</strong>Contest on .
                <strong>@StatementGames!</strong>
                ! The Winner gets a DOPE BS3 Sports Shirt!
                <strong>#DallasCowboys #CowboysNation #Redskins #HTTP</strong>
              </p>

              <p class="play-mg-btm">Make sure to follow
                <strong>@StatementGames </strong> and tag a friend in this post!</p>

              <p class="play-mg-btm">Click Here:
                <br>
                <strong>statementgames.com/#/landing/sign</strong>
              </p>

            </div>
          </div>
          <!-- <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div> -->
        </div>
      </div>
    </div>

    <section id="clients" class="clients-logo pad-sec bg-lgt-red">
      <div class="container">
        <div class="as-seen-logo text-center">
          <img src="assets/img/as-seen-logo.png" alt="">
        </div>

        <div class="section-header"> </div>
        <div class="owl-carousel clients-carousel">
          <img src="assets/img/cmpy1.png" />
          <img src="assets/img/cmpy2.png" />
          <img src="assets/img/cmpy3.png" />
          <img src="assets/img/cmpy4.png" />
          <img src="assets/img/cmpy5.png" />
        </div>
      </div>
    </section>
  </div>

  <footer>
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <div class="address-sec">
            <img src="assets/img/SG-landing-page-logo.png" width="280px" />
            <address>
              <p>
                <i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp;New York, USA.</p>
              <p>
                <!-- <i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;support@statementgames.com -->
                <i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;
                <a href="mailto:marketing@statementgames.com">marketing@statementgames.com</a>
              </p>
              <!-- <p>
                <a href="javascript:void(0)">
                  <i class="fa fa-phone" aria-hidden="true"></i>&nbsp;1-833-232-1702</a>
              </p> -->
            </address>
          </div>
        </div>
        <div class="col-sm-4 ftr-link">
          <h4>Our Links</h4>
          <ul>
            <!-- <li>
              <a href="javascript:void(0)">About</a>
            </li>
            <li>
              <a href="javascript:void(0)">Blog</a>
            </li>
            <li>
              <a href="javascript:void(0)">FAQ</a>
            </li>
            <li>
              <a href="javascript:void(0)">Privacy Policy</a>
            </li>
            <li>
              <a href="javascript:void(0)">Rules</a>
            </li>
            <li>
              <a href="javascript:void(0)">Support</a>
            </li>
            <li>
              <a href="javascript:void(0)">Terms & Conditions</a>
            </li> -->

            <li *ngFor="let footer of footers" (click)="loadFooterContent(footer)">
              <a href="javascript:void(0);">{{footer.title}}</a>
            </li>

          </ul>
        </div>
        <div class="col-sm-3 social-sec">

          <h4>Social Connect:</h4>
          <ul class="social-links list-inline">
            <li>
              <a href="https://www.facebook.com/StatementGames/" target="_blank">
                <i class="fa fa-facebook fnt25" aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/statementgames" target="_blank">
                <i class="fa fa-twitter fnt25" aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/statementgames/" target="_blank">
                <i class="fa fa-instagram fnt25"  aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCZtETt-wK0OnF_AHbQ5RRhQ?view_as=subscriber " target="_blank">
                <i class="fa fa-youtube fnt25" aria-hidden="true"></i>
              </a>
            </li>
            <!-- <li>
                  <a href="javascript:void(0)">
                    <i class="fa fa-linkedin" aria-hidden="true"></i>
                  </a>
                </li> -->
            <!-- <li>
                  <a href="https://plus.google.com/u/0/104605028988485215379" target="_blank">
                    <i class="fa fa-google" aria-hidden="true"></i>
                  </a>
                </li> -->
          </ul>

        </div>

      </div>
    </div>
    <div class="footer-btm">
      <div class="container text-center">
        <p>{{currentYear}} StatementGames Inc.</p>
      </div>
    </div>
  </footer>




</div>